'use strict';
module.exports = Number.isNaN || function (x) {
	return x !== x;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/number-is-nan/index.js
 ** module id = 451
 ** module chunks = 0
 **/